const tremus_style = {
    colorButtonPrimary: "teal",
    bg_default: "linear-gradient(to right, #1061b7, #00b1b1)"
}

module.exports = {
    tremus_style
}